module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "applications"
  }, [_c('p', [_vm._v("Entscheide Dich zeitnah, bei welchen Schichten Du arbeiten möchtest.\nWenn der Schichtplan fertig ist, bekommst Du eine Mail.")]), _c('ul', _vm._l((_vm.days), function(day, index) {
    return _c('li', {
      staticClass: "day",
      class: {
        'gray': index % 2 === 0
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("moment")(day.date, 'dd. Do MMM ')))]), _c('div', {
      staticClass: "events"
    }, _vm._l((day.events), function(event) {
      return _c('div', {
        staticClass: "event"
      }, [_c('dl', [_c('dt', [_vm._v(_vm._s(event.badge))]), _c('dd', [_vm._v(_vm._s(_vm._f("moment")(event.start, 'HH:mm')) + " - " + _vm._s(event.name))])])])
    }), 0), _vm._l((day.applications), function(application) {
      return _c('div', {
        staticClass: "application"
      }, [_c('application', {
        attrs: {
          "application": application
        }
      })], 1)
    })], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a35748e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Applications.vue
// module id = 1084
// module chunks = 1